<main *transloco="let t" class="container">
  <div class="row min-vh-100 align-items-center justify-content-center">
    <div class="col-12 col-md-8 col-lg-6 d-flex flex-column justify-content-center align-items-center text-center">
      <img src="assets/img/logo/iSophi_podpora_pedagoga.svg" alt="isophi" class="img-fluid mb-5" style="max-width: 300px" />
      <p>{{ t('workInProgress/title') }}</p>
      <a type="button" class="btn btn-primary d-flex gap-2 align-items-center fw-bold mx-auto" href="https://podporapedagoga.cz">
        <i class="material-symbols-rounded filled">school</i>
        <span>{{ t('workInProgress/cta') }}</span>
      </a>
      <div (click)="handleLogout()" class="btn btn-light-outline d-flex gap-2 align-items-center fw-bold mx-auto mt-3">
        <span>{{ t('shared/logOut') }}</span>
      </div>
    </div>
  </div>
</main>
